import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { mockCampaignContext } from "../../helpers/mockCampaignContext";
import { MarketCampaignContext } from "../market-campaign/MarketCampaign.context-state";

const WhatsAppTemplateListV2 = Loadable(
  lazy(() =>
    import("./WhatsAppTemplateListV2").then(({ WhatsAppTemplateListV2 }) => ({
      default: WhatsAppTemplateListV2,
    })),
  ),
);

const ManageWhatsAppTemplate = Loadable(
  lazy(() =>
    import("./ManageWhatsAppTemplate").then(({ ManageWhatsAppTemplate }) => ({
      default: ManageWhatsAppTemplate,
    })),
  ),
);

export const marketCampaign = [
  {
    path: "/meta-templates",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <MarketCampaignContext.Provider value={mockCampaignContext}>
          <WhatsAppTemplateListV2 />
        </MarketCampaignContext.Provider>
      </AuthorizedRoute>
    ),
  },
  {
    path: "/meta-templates/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <ManageWhatsAppTemplate />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/meta-templates/manage/:metaId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.META_TEMPLATE]}>
        <ManageWhatsAppTemplate />
      </AuthorizedRoute>
    ),
  },
];
